/* ALIZÉ — fixes JS 2026-07-07 : sticky ATC mobile, étoiles remplies, swatches couleur */
(function () {
  // 1. Sticky ATC mobile
  if (window.matchMedia('(max-width: 900px)').matches) {
    var sticky = document.querySelector('.cft-pp__sticky-atc');
    var mainBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] [name="add"]');
    if (sticky && mainBtn) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('alz-visible', passed);
        sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }, { threshold: 0 });
      io.observe(mainBtn);
    }
  }

  // 2. Étoiles remplies selon la note (les glyphes ☆ vides deviennent ★ pleines)
  function fillStars() {
    document.querySelectorAll('.cft-pp__stars, .cft-pp__reviews-stars').forEach(function (el) {
      var ctx = el.closest('.cft-pp__rating, .cft-pp__reviews-summary') || el.parentElement;
      var m = (ctx ? ctx.textContent : '').match(/([0-9]+[.,][0-9]+|[0-9]+)\s*\/\s*5/);
      var note = m ? parseFloat(m[1].replace(',', '.')) : 5;
      var full = Math.max(0, Math.min(5, Math.round(note)));
      el.textContent = '★'.repeat(full) + '☆'.repeat(5 - full);
    });
  }

  // 3. Swatches : remplir le cercle selon la couleur du libellé
  var COLORS = [
    ['blanc ivoire', '#F5EFE0'], ['ivoire', '#F5EFE0'], ['noir', '#0E0E10'], ['blanc', '#FFFFFF'],
    ['beige', '#D8C3A5'], ['noyer', '#6B4A2F'], ['bois foncé', '#6B4A2F'], ['bois clair', '#C8A165'],
    ['blond', '#C8A165'], ['chêne', '#C8A165'], ['naturel', '#C8A165'], ['argent', '#C0C0C0'],
    ['gris', '#9AA0A6'], ['bois', '#A97E4F']
  ];
  function fillSwatches() {
    document.querySelectorAll('.cft-pp__variant-option').forEach(function (opt) {
      var sw = opt.querySelector('.cft-pp__swatch');
      var label = opt.querySelector('.cft-pp__swatch-label');
      if (!sw || !label) return;
      var txt = label.textContent.toLowerCase();
      for (var i = 0; i < COLORS.length; i++) {
        if (txt.indexOf(COLORS[i][0]) !== -1) {
          sw.style.background = COLORS[i][1];
          sw.classList.add('alz-filled');
          break;
        }
      }
    });
  }

  function runAll() { fillStars(); fillSwatches(); }
  runAll();
  // re-appliquer si le picker de variantes se re-rend
  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) form.addEventListener('change', function () { setTimeout(runAll, 150); });
  document.addEventListener('shopify:section:load', runAll);
})();
